const { REACT_APP_CIRCLE_BRANCH, BRANCH } = process.env

import * as Sentry from '@sentry/react'

import { isProductionEnvironment, isTestEnvironment } from 'utils/environment'

export default {
  error(err) {
    if (isProductionEnvironment()) {
      if (err.response) return

      // Give us detailed information about the error if it's available.
      // This is particularly useful with Axios errors.
      if (Sentry) {
        try {
          Sentry.captureException(err)
        } catch (err) {
          console.error('Unable to capture exception using Sentry:', err)
        }
      }
    }

    if (
      REACT_APP_CIRCLE_BRANCH === 'master' ||
      BRANCH === 'master' ||
      isTestEnvironment()
    )
      return

    console.error(err)
  }
}
